import { PreviewForward, TrashIcon } from '@/assets/images';
import { useChatFeature } from '@/features/chats/chatsRegistry';
import { toggleMessageSelection, useIsAnyMessageSelected } from '@/features/chats/model';
import { useLanguage } from '@/localization/useLanguage';
import { blockOfflineAction, getUserIdFromJid } from '@/shared/utils';
import { useMemo } from 'react';
import { useDispatch } from 'react-redux';

const EMPTY_FEATURES = {};

export const useMediaGroupActionDropdown = ({ message, activeChatJid }) => {
   const { t } = useLanguage();
   const dispatch = useDispatch();
   const activeChatId = useMemo(() => getUserIdFromJid(activeChatJid), [activeChatJid]);
   const messageActionFeatures = useChatFeature('message-action') || EMPTY_FEATURES;
   const isAnyMessageSelected = useIsAnyMessageSelected(activeChatId);

   const messages = useMemo(() => {
      return message?.messages ?? [];
   }, [message.messages]);

   const allMsgStatus = messages.length > 0 && messages.every(m => m.msgStatus < 3);

   const groupMsgId = message.msgId;

   const chatMenuItems = useMemo(() => {
      if (isAnyMessageSelected || !allMsgStatus) return [];

      return [
         messageActionFeatures['message-action-forward'] && {
            id: 'forward-all',
            icon: <PreviewForward />,
            label: t('message.ACTION_FORWARD_ALL'),
            action: () => {
               if (blockOfflineAction()) return;
               dispatch(
                  toggleMessageSelection({
                     chatId: activeChatId,
                     msgId: groupMsgId,
                     selectionType: 'forward',
                  }),
               );
            },
         },
         messageActionFeatures['message-action-delete'] && {
            id: 'delete-all',
            icon: <TrashIcon />,
            label: t('message.ACTION_DELETE_ALL'),
            action: () => {
               if (blockOfflineAction()) return;
               dispatch(
                  toggleMessageSelection({
                     chatId: activeChatId,
                     msgId: groupMsgId,
                     selectionType: 'delete',
                  }),
               );
            },
            className: 'danger',
         },
      ].filter(Boolean);
   }, [isAnyMessageSelected, messageActionFeatures, activeChatId, groupMsgId, allMsgStatus, dispatch, t]);

   return { chatMenuItems };
};
